export default __webpack_public_path__ + "graphics/arrow.837a46ff.png";